import React, { Fragment } from 'react';
import Media from 'react-media';
import { IValidationFormItems } from './Interfaces';
import moment from 'moment';
import { TimeSend } from './content/Constants';

export const bodyHidden = () => {
  document.querySelector('body')?.classList.add('body-hidden');
};
export const bodyAuto = () => {
  document.querySelector('body')?.classList.remove('body-hidden');
};
export const htmlScroll = () => {
  setTimeout(() => document.querySelector('html')?.classList.add('scroll'), 1000);
};
export const htmlNoScroll = () => {
  document.querySelector('html')?.classList.remove('scroll');
};

export const MediaContent = (
  contentLarge: React.ReactElement | null,
  contentMedium: React.ReactElement | null
) => {
  return (
    <Media
      queries={{
        medium: 'screen and (max-width: 720px)',
        large: 'screen and (min-width: 721px)',
      }}
    >
      {(matches) => (
        <Fragment>
          {matches.medium && contentMedium}
          {matches.large && contentLarge}
        </Fragment>
      )}
    </Media>
  );
};

export const DeclOfNum = (n: number, textForms: string[]) => {
  n = Math.abs(n) % 100;
  const n1 = n % 10;
  if (n > 10 && n < 20) {
    return textForms[2];
  }
  if (n1 > 1 && n1 < 5) {
    return textForms[1];
  }
  if (n1 === 1) {
    return textForms[0];
  }
  return textForms[2];
};

export const ValidationFormItems = ({ fields, arrSetError, phone, setErrorPhone }: IValidationFormItems) => {
  if (fields && arrSetError) {
    fields.forEach((item, i) => {
      arrSetError[i](null);
    });
  }
  setErrorPhone(null);

  let err = 0;

  if (fields && arrSetError) {
    fields.forEach((item, i) => {
      if (item.length === 0) {
        arrSetError[i]('Пожалуйста, заполните поле');
        err = 1;
      }
    });
  }

  if (phone && (phone === '+7 (___) ___-__-__' || phone.replace(/[^0-9]/g, '').length < 11)) {
    setErrorPhone('Пожалуйста, заполните поле');
    err = 1;
  }

  if (err) {
    return false;
  }

  if (fields && arrSetError) {
    fields.forEach((item, i) => {
      arrSetError[i](null);
    });
  }
  setErrorPhone(null);
  return true;
};

export const PrintedText = (ListText: string[][], setText: any) => {
  let Counter = 0;
  let TextPrint = '';
  let NumText = 0;
  let ArrTexts: string[] = ListText[NumText];
  let intervalId: { current: NodeJS.Timer | undefined } = { current: undefined };

  clearInterval(intervalId.current);
  intervalId.current = setInterval(() => {
    TextPrint = `${TextPrint}${ArrTexts[Counter]}`;
    setText(TextPrint);

    if (Counter === ListText[NumText].length - 1) {
      Counter = 0;
      TextPrint = '';

      if (NumText === ListText.length - 1) {
        NumText = 0;
      } else {
        NumText++;
      }

      ArrTexts = ListText[NumText];
    } else {
      Counter++;
    }
  }, 100);
};

export const GetTypeNews = (type: string) => {
  switch (type) {
    case 'blog':
      return 'Блог';
    default:
      return 'Новости';
  }
};

export const CheckBlockedSend = (blockedSendLoaded: any) => {
  const countMin = 5;
  const countMMSec = 1000 * 60 * countMin;
  const timeLastSend = localStorage.getItem(TimeSend);

  if (timeLastSend) {
    const now = new Date().getTime().toString();
    const timePassed = parseInt(now) - parseInt(timeLastSend);

    if (timePassed > countMMSec) {
      localStorage.removeItem(TimeSend);
      blockedSendLoaded({ state: false, counter: 0 });
      return;
    }

    const idInterval = setInterval(() => {
      const now = new Date().getTime().toString();
      const timePassed = parseInt(now) - parseInt(timeLastSend);

      const sec: number = (countMMSec - timePassed) / 1000;
      const printTime = moment(new Date(0, 0, 0, sec / 60, sec % 60)).format('HH:mm');

      blockedSendLoaded({ state: true, counter: printTime });
    }, 1000);

    setTimeout(() => {
      localStorage.removeItem('timeSend');
      blockedSendLoaded({ state: false, counter: 0 });
      clearInterval(idInterval);
    }, countMMSec - timePassed);
  }
};

export const ClosedSubMenuComponent = () => {
  const popups = document.querySelectorAll('.menu-top__sub-component');
  popups.forEach((x) => x.classList.add('menu-top__sub-component_close'));
  setTimeout(() => popups.forEach((x) => x.classList.remove('menu-top__sub-component_close')), 500);
};

export const AdaptiveValue = ({ widthWindow, value }: { widthWindow: number; value: string }) => {
  if (widthWindow > 720 && widthWindow < 1440 && value.slice(-2) === 'px') {
    return `${parseInt(value.slice(0, -2)) / 14.4}vw`;
  }

  return value;
};

export const TransformBgImage = ({
  widthWindow,
  offsetContent,
}: {
  widthWindow: number;
  offsetContent: number;
}) => {
  return {
    transform: `translateX(-${offsetContent}px) translateY(-${
      widthWindow > 1439 ? '124px' : widthWindow > 720 ? `${124 / 14.4}vw` : '106px'
    })`,
  };
};
